import React from 'react'
import { SwitchButton } from 'atoms/SwitchButton'
import translate from '../../../../core/translate'
import { styles } from './ivideonEvents.jcss'
import { cn } from 'ethcss'
import { grid } from '../../../../theme'
import EditText from '../../../../blocks.simple/editText/editText'
import { WikiInfo } from '../../../../blocks.simple/wikiInfo/WikiInfo'
import Checkbox from '../../../../blocks.simple/checkbox/checkbox'

type Event = {
    event: string
    selected: boolean
}

export interface IIvideonEvents {
    isEnabled: boolean
    apiKey: string
    events: Event[]
}

export const IvideonEvents = (p_: {
    data: IIvideonEvents
    onChange: (value: any, field: string, integrationName: string) => void
}) => {
    return (
        <div>
            <div className={styles.titleWrapper}>
                <div className={styles.title}>{translate('ivideonEvents')}</div>
                <WikiInfo blockKey={'settings'} blockSubKey={'integrations'} infoKey={'ivideonEvents'} />
            </div>
            <div className={styles.optionWrapper}>
                <div className={styles.optionCaption}>{translate('useIvideonEvents')}</div>
                <SwitchButton
                    onChange={() => {
                        p_.onChange(!p_.data.isEnabled, 'isEnabled', 'ivideonEvents')
                    }}
                    checked={p_.data.isEnabled}
                />
            </div>
            <div className={styles.optionWrapper}>
                <div className={styles.optionCaption}>{translate('apiKey')}</div>
                <EditText
                    className={cn(styles.input)}
                    value={p_.data.apiKey}
                    mod="withLightBorder"
                    onChange={(value: string) => {
                        p_.onChange(value, 'apiKey', 'ivideonEvents')
                    }}
                />
            </div>
            <div className={styles.optionWrapper}>
                <div className={styles.optionCaption}>{translate('events')}</div>
                {p_.data.events.map((event) => {
                    return (
                        <Checkbox
                            key={event.event}
                            onClick={(selected: boolean) => {
                                p_.onChange(
                                    p_.data.events.map((item) => {
                                        if (item.event === event.event) {
                                            return {
                                                ...item,
                                                selected,
                                            }
                                        }

                                        return item
                                    }),
                                    'events',
                                    'ivideonEvents'
                                )
                            }}
                            className={cn(grid.mb_mini, grid.mt_mini)}
                            labelClassName={styles.checkboxLabel}
                            label={translate(event.event)}
                            checked={event.selected}
                        />
                    )
                })}
            </div>
        </div>
    )
}
